import React, { useState } from "react";
import { Copy, ExternalLink, Check, ShieldCheck } from "lucide-react";
import { transparentAccount } from "../mock";
import { useToast } from "../hooks/use-toast";

const Transparent = () => {
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  const copy = () => {
    navigator.clipboard.writeText(transparentAccount.iban.replace(/\s/g, ""));
    setCopied(true);
    toast({ title: "IBAN skopírovaný" });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="bg-campaign-coral py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-campaign-cream border-4 border-campaign-ink shadow-brutal-lg p-6 sm:p-10">
          <div className="inline-flex items-center gap-2 bg-campaign-blue text-campaign-cream font-bold uppercase text-xs px-3 py-1.5 border-2 border-campaign-ink mb-5">
            <ShieldCheck size={16} /> 100% transparentne
          </div>
          <h2 className="font-display text-3xl sm:text-5xl text-campaign-ink leading-none mb-4">
            {transparentAccount.heading}
          </h2>
          <p className="text-campaign-ink/85 text-base sm:text-lg mb-8 max-w-2xl">
            {transparentAccount.text}
          </p>

          <div className="bg-campaign-yellow border-4 border-campaign-ink p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex-1">
              <span className="block text-xs font-bold uppercase tracking-widest text-campaign-ink/60 mb-1">
                Číslo účtu vo VÚB banke (IBAN)
              </span>
              <span className="font-display text-lg sm:text-2xl text-campaign-ink break-all">
                {transparentAccount.iban}
              </span>
            </div>
            <button
              onClick={copy}
              className="shrink-0 inline-flex items-center justify-center gap-2 bg-campaign-ink text-campaign-cream font-bold uppercase px-4 py-3 border-2 border-campaign-ink hover-lift"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
              {copied ? "Skopírované" : "Kopírovať"}
            </button>
          </div>

          <a
            href={transparentAccount.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 bg-campaign-blue text-campaign-cream font-display uppercase text-base px-6 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
          >
            Prispieť cez PAYME <ExternalLink size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Transparent;
